export const resourceTypes = ["全部", "白皮书", "研究报告", "工具下载", "培训资料", "常见问题"];
export const resourceFields = ["全部", "技术研发", "市场运营", "品牌传播", "客户服务", "行业研究"];

export const resourceList = [
  {
    id: "r1",
    title: "想要XX 品牌白皮书 2026 版",
    type: "白皮书",
    field: "品牌传播",
    updatedAt: "2026-09-20",
    format: "PDF",
    size: "8.6 MB",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20stack%20of%20premium%20report%20covers%20in%20blue%20gray%20with%20an%20orange%20spine%20accent%20on%20a%20pale%20gray%20desk%2C%20soft%20studio%20lighting%2C%20clean%20editorial%20product%20photography&width=1200&height=800&seq=res-whitepaper-01&orientation=landscape",
    summary:
      "系统梳理想要XX 的品牌定位、视觉语言与传播方法论，适合品牌与市场从业者作为参考资料。",
    tags: ["品牌定位", "视觉语言", "传播方法"],
    content: [
      {
        heading: "内容概览",
        paragraphs: [
          "白皮书共五个章节，覆盖品牌定位、核心价值、视觉规范、传播策略与案例拆解。",
        ],
      },
      {
        heading: "适用对象",
        paragraphs: [
          "品牌管理、市场传播、内容运营等相关岗位，以及关注品牌建设的研究者。",
        ],
      },
      {
        heading: "获取说明",
        paragraphs: [
          "当前为前端演示资源，下载功能待后续接入真实文件服务后开放。",
        ],
      },
    ],
  },
  {
    id: "r2",
    title: "品牌信息透明化趋势研究报告",
    type: "研究报告",
    field: "行业研究",
    updatedAt: "2026-09-05",
    format: "PDF",
    size: "5.2 MB",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20research%20report%20cover%20with%20charts%20and%20fine%20grid%20lines%20in%20blue%20gray%20and%20a%20warm%20orange%20data%20line%2C%20minimal%20editorial%20graphic&width=1200&height=800&seq=res-research-01&orientation=landscape",
    summary:
      "基于公开资料与调研数据，分析用户信息检索习惯的变化，以及透明化对品牌信任的影响。",
    tags: ["信息检索", "用户调研", "信任"],
    content: [
      {
        heading: "研究方法",
        paragraphs: [
          "研究综合公开数据、问卷调研与访谈，形成对行业趋势的定性判断与量化参考。",
        ],
      },
      {
        heading: "主要结论",
        paragraphs: [
          "信息透明化与检索便捷度，正成为影响用户品牌选择的重要因素。",
        ],
      },
      {
        heading: "获取说明",
        paragraphs: [
          "当前为演示内容，报告全文下载待后端资源服务接入后开放。",
        ],
      },
    ],
  },
  {
    id: "r3",
    title: "品牌视觉资源包（演示）",
    type: "工具下载",
    field: "品牌传播",
    updatedAt: "2026-08-28",
    format: "ZIP",
    size: "24.3 MB",
    cover:
      "https://readdy.ai/api/search-image?query=Neat%20flat%20lay%20of%20brand%20design%20assets%20including%20color%20cards%20and%20shape%20cutouts%20in%20blue%20gray%20and%20orange%2C%20pale%20gray%20background%2C%20clean%20editorial%20photography&width=1200&height=800&seq=res-kit-01&orientation=landscape",
    summary:
      "包含品牌常用配色、基础图形与版式示例，供合作方与设计人员参考使用。",
    tags: ["设计资源", "配色", "版式"],
    content: [
      {
        heading: "包含内容",
        paragraphs: [
          "资源包内含配色规范、基础图形素材与常用版式示例，均为演示用途。",
        ],
      },
      {
        heading: "使用规范",
        paragraphs: [
          "请在品牌规范的授权范围内使用，避免对品牌标识进行二次修改。",
        ],
      },
      {
        heading: "获取说明",
        paragraphs: [
          "当前为前端演示，点击下载不会获取真实文件。",
        ],
      },
    ],
  },
  {
    id: "r4",
    title: "内容运营实操手册",
    type: "培训资料",
    field: "市场运营",
    updatedAt: "2026-08-12",
    format: "PDF",
    size: "3.9 MB",
    cover:
      "https://readdy.ai/api/search-image?query=Open%20notebook%20with%20clean%20checklists%20and%20a%20pen%20on%20a%20pale%20gray%20desk%2C%20soft%20warm%20daylight%2C%20blue%20gray%20stationery%20with%20orange%20highlights%2C%20minimal%20editorial%20photography&width=1200&height=800&seq=res-handbook-01&orientation=landscape",
    summary:
      "面向内容运营岗位的入门到进阶手册，涵盖选题、编辑、发布与复盘的完整流程。",
    tags: ["内容运营", "流程", "复盘"],
    content: [
      {
        heading: "章节结构",
        paragraphs: [
          "手册从选题方法讲起，逐步覆盖编辑规范、发布节奏与数据复盘。",
        ],
      },
      {
        heading: "亮点",
        paragraphs: [
          "每个章节都配有可直接套用的清单，便于日常工作中查阅。",
        ],
      },
      {
        heading: "获取说明",
        paragraphs: [
          "演示资源，正式版本将在资源服务接入后提供。",
        ],
      },
    ],
  },
  {
    id: "r5",
    title: "客户服务常见问题解答（FAQ）",
    type: "常见问题",
    field: "客户服务",
    updatedAt: "2026-07-30",
    format: "网页",
    size: "-",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20abstract%20speech%20bubbles%20in%20blue%20gray%20with%20one%20orange%20bubble%2C%20clean%20flat%20illustration%20on%20light%20gray%20background%2C%20editorial%20graphic&width=1200&height=800&seq=res-faq-01&orientation=landscape",
    summary:
      "汇总用户最常咨询的问题与解答，覆盖合作流程、资料获取与联系方式等主题。",
    tags: ["FAQ", "服务支持"],
    content: [
      {
        heading: "高频问题",
        paragraphs: [
          "涵盖合作接洽、资料申请、信息纠错与反馈渠道等常见问题。",
        ],
      },
      {
        heading: "问题反馈",
        paragraphs: [
          "如未找到所需答案，可通过联系我们页面提交问题。",
        ],
      },
      {
        heading: "获取说明",
        paragraphs: [
          "FAQ 为在线浏览内容，如需反馈请使用联系表单。",
        ],
      },
    ],
  },
  {
    id: "r6",
    title: "技术研发人才能力参考模型",
    type: "研究报告",
    field: "技术研发",
    updatedAt: "2026-07-16",
    format: "PDF",
    size: "4.4 MB",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20skill%20matrix%20concept%20with%20grid%20of%20small%20squares%20in%20blue%20gray%20and%20orange%20progress%20bars%2C%20clean%20minimal%20editorial%20illustration&width=1200&height=800&seq=res-skill-01&orientation=landscape",
    summary:
      "从能力维度拆解技术研发岗位的成长路径，为团队建设与个人发展提供参考框架。",
    tags: ["能力模型", "人才发展"],
    content: [
      {
        heading: "能力维度",
        paragraphs: [
          "模型从基础能力、工程能力、协作能力三个维度描述不同职级的参考标准。",
        ],
      },
      {
        heading: "使用方式",
        paragraphs: [
          "可用于团队内部的能力盘点与发展规划。",
        ],
      },
      {
        heading: "获取说明",
        paragraphs: [
          "演示资源，完整模型待正式发布。",
        ],
      },
    ],
  },
  {
    id: "r7",
    title: "数据化运营指标清单",
    type: "工具下载",
    field: "市场运营",
    updatedAt: "2026-06-28",
    format: "XLSX",
    size: "1.2 MB",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20dashboard%20mockup%20with%20clean%20charts%20in%20blue%20gray%20and%20an%20orange%20highlight%20line%2C%20soft%20shadow%20on%20light%20gray%20background%2C%20editorial%20graphic&width=1200&height=800&seq=res-metrics-01&orientation=landscape",
    summary:
      "整理常用的运营核心指标与计算口径，帮助团队建立统一的指标认知。",
    tags: ["指标", "数据运营"],
    content: [
      {
        heading: "清单内容",
        paragraphs: [
          "覆盖拉新、活跃、留存与转化等环节的常用指标及口径说明。",
        ],
      },
      {
        heading: "使用建议",
        paragraphs: [
          "建议结合团队实际目标选取指标，避免过度堆砌。",
        ],
      },
      {
        heading: "获取说明",
        paragraphs: [
          "演示资源，暂不提供真实文件下载。",
        ],
      },
    ],
  },
  {
    id: "r8",
    title: "新用户入门指南",
    type: "培训资料",
    field: "客户服务",
    updatedAt: "2026-06-10",
    format: "网页",
    size: "-",
    cover:
      "https://readdy.ai/api/search-image?query=Welcoming%20minimal%20guide%20cover%20with%20numbered%20steps%20in%20blue%20gray%20and%20orange%20markers%20on%20light%20gray%20background%2C%20clean%20editorial%20graphic&width=1200&height=800&seq=res-guide-01&orientation=landscape",
    summary:
      "帮助首次访问的用户快速了解平台结构，找到品牌介绍、资讯与资源三大板块的入口。",
    tags: ["入门指南", "使用说明"],
    content: [
      {
        heading: "如何使用本平台",
        paragraphs: [
          "从导航进入品牌介绍、相关资讯或资源查询，即可开始浏览对应内容。",
        ],
      },
      {
        heading: "检索技巧",
        paragraphs: [
          "使用顶部搜索可跨板块查找关键词，分类页支持多条件筛选。",
        ],
      },
      {
        heading: "获取说明",
        paragraphs: [
          "在线浏览内容，无需下载。",
        ],
      },
    ],
  },
];